type MatcherTypes = "M_REGEX" | "M_FUZZY" | "M_LOCATION";

const MatcherTypesKeys: MatcherTypes[] = ["M_FUZZY", "M_REGEX", "M_LOCATION"];

const isMatcherTypes = (value: string): value is MatcherTypes => {
  return MatcherTypesKeys.indexOf(value as MatcherTypes) > -1;
};

const getMatcherTypes = () => {
  return [...MatcherTypesKeys];
};

const getMatcherTypesDisplayValue = (key: MatcherTypes): string => {
  switch (key) {
    case "M_REGEX":
      return "Regex";
    case "M_FUZZY":
      return "Fuzzy";
    case "M_LOCATION":
      return "Location";
    default:
      return key;
  }
};

export {
  MatcherTypes,
  isMatcherTypes,
  getMatcherTypes,
  getMatcherTypesDisplayValue,
};
